import React from "react"
import BackgroundImageHome from "@components/MockableImages/background"
import TwoComponents from "@modules/TwoColumns/twoComponents"
import { useBreakpoints } from "@hooks/useBreakpoints"

import Markdown from "@components/Markdown"
const getStylesBasedOnTheme = theme => {
  switch (theme) {
    case "blue":
      return {
        titleColor: "text-white",
        fontColor: "text-[#B9B8BD]",
      }
    case "white":
      return { fontColor: "text-[#5B5866]" }
    case "lBlue":
      return {
        fontColor: "text-[#5B5866]",
      }
    default:
      return {}
  }
}

const RenderElement = ({
  data,
  otherData,
  elementType,
  classNames,
  isMobile,
}) => {
  const content = data || otherData

  if (!content) return null

  const classes = `${otherData && !data ? "invisible" : ""} ${classNames} ${
    otherData && !data && isMobile ? "hidden" : ""
  }`

  if (elementType === "img") {
    return (
      <div>
        <img className={classes} src={content} />
      </div>
    )
  }

  if (elementType === "div") {
    return <div className={classes}>{content}</div>
  }

  if (elementType === "h2") {
    return <h2 className={classes}>{content}</h2>
  }

  return null
}

const buildComponent = (column, theme, otherColumn, isMobile, index) => {
  const { titleColor, fontColor } = getStylesBasedOnTheme(theme)

  if (column.img) {
    return (
      <div
        className={`${column.classes?.img} md:pl-[8px] md:h-[100%] mb-[24px] w-full md:mb-0 desk:pl-[16px]`}
      >
        <BackgroundImageHome image={column.img} />
      </div>
    )
  }

  return (
    <div
      className={`flex flex-col px-[24px]  py-[0] md:pl-[0] md:pr-[64px] desk:pr-[150px]  `}
    >
      <RenderElement
        isMobile={isMobile}
        data={column.label}
        otherData={otherColumn?.label}
        elementType="div"
        classNames={` w-fit text-center bg-[#52F597] uppercase font-inter text-[11px] py-[3px] px-[4px] font-bold md:font-semibold leading-[12px] tracking-[0.88px] desk:leading-[14px] desk:text-[12px]`}
      />

      <RenderElement
        isMobile={isMobile}
        data={column.icon}
        otherData={otherColumn?.icon}
        elementType="img"
        classNames="h-[64px] mt-[12px] mb-[16px] desk:w-[100px] desk:h-[100px] desk:my-[24px] "
      />

      <RenderElement
        isMobile={isMobile}
        data={column.title}
        otherData={otherColumn?.title}
        elementType="h2"
        classNames={`font-inter text-[20px] leading-[120%] font-medium mb-[8px] ${titleColor} desk:mb-[20px] desk:text-[40px] desk:leading-normal`}
      />

      <div className="desk:mb-[0px] desk:h-[100%] desk:flex desk:flex-col  ">
        {column.arrtext.map((text, index) => (
          <p
            key={index}
            className={`
              font-inter 
              leading-[150%] 
              mb-[16px] 
              text-[14px] 
              
              desk:text-[20px]
              ${column.arrtext.length - 1 !== index ? "md:!mb-4" : ""}
              ${column.classes?.paragraph} 
              ${fontColor} 
              ${
                index === column.arrtext.length - 1
                  ? column.classes?.lastParagraph
                  : ""
              }
              `}
          >
            <Markdown>{text}</Markdown>
          </p>
        ))}
      </div>
    </div>
  )
}

const TwoColumnIconTextCombo = ({
  theme = "blue",
  col1content = {
    icon: "",
    label: "",
    title: "",
    arrtext: [],
    img: null,
    classes: {},
  },
  col2content = {
    icon: "",
    label: "",
    title: "",
    arrtext: [],
    img: null,
    classes: {},
  },
  col1class = "",
  col2class = "",
  containerClass = "",
  reverse = false,
  backgroundImage = null,
  backgroundStyle = null,
  extraBackgroundClass = {},
}) => {
  const { isMobile } = useBreakpoints()

  return (
    <TwoComponents
      theme={theme}
      col1content={buildComponent(col1content, theme, col2content, isMobile, 1)}
      col2content={buildComponent(col2content, theme, col1content, isMobile, 2)}
      col1class={col1class}
      col2class={col2class}
      containerClass={`${containerClass} ${
        !col2content.img && !col1content.img ? "pt-[40px]" : ""
      } pb-[24px] md:px-[44px] md:py-[40px] desk:py-[100px] desk:px-[100px]  `}
      reverse={reverse}
      backgroundImage={backgroundImage}
      backgroundStyle={backgroundStyle}
      extraBackgroundClass={extraBackgroundClass}
    />
  )
}

export default TwoColumnIconTextCombo
